import React, { createContext } from 'react';
import { ImpactClaimsProvider } from './ImpactClaimsProvider';
const PageDataContext = createContext({
    pageData: undefined,
});
const PageDataConsumer = PageDataContext.Consumer;
const PageDataProvider = ({ children, pageData }) => {
    const state = {
        pageData,
    };
    return (React.createElement(PageDataContext.Provider, { value: state },
        React.createElement(ImpactClaimsProvider, { impactClaims: pageData.impactClaims }, children)));
};
export { PageDataConsumer, PageDataProvider };
export default PageDataContext;
